import { defineComponent as n, openBlock as r, createBlock as l, unref as p, mergeProps as m, withCtx as c, createElementVNode as e } from "vue";
import { RevIcon as i } from "@ds/components/Icon";
const d = /* @__PURE__ */ n({
  name: "IconRepairHome",
  __name: "IconRepairHome",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(t) {
    const o = t;
    return (s, a) => (r(), l(p(i), m(o, { "view-box": "0 0 24 24" }), {
      default: c(() => [...a[0] || (a[0] = [
        e("path", { d: "M11.232 3a1.25 1.25 0 0 1 1.535 0l8.693 6.761a.75.75 0 1 1-.92 1.184L12 4.303l-8.54 6.642a.75.75 0 1 1-.92-1.184L11.231 3" }, null, -1),
        e("path", { d: "M5 11a.75.75 0 0 1 .75.75v6.75h8.75a.75.75 0 0 1 0 1.5h-9a1.25 1.25 0 0 1-1.25-1.25v-7A.75.75 0 0 1 5 11m14 0a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0v-3A.75.75 0 0 1 19 11" }, null, -1),
        e("path", { d: "M15.06 11.317c.836.837 1.082 2.263.575 3.403l5.082 5.083a1 1 0 1 1-1.414 1.414l-5.083-5.082c-1.14.507-2.566.261-3.403-.575-1.001-1-.939-2.358-.817-3.064.038-.22.296-.286.454-.128l1.69 1.69a.3.3 0 0 0 .212.088h.99a.3.3 0 0 0 .3-.3v-.99a.3.3 0 0 0-.088-.212l-1.69-1.69c-.158-.158-.092-.416.128-.454.706-.122 2.063-.184 3.064.817" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  d as default
};
